<template>
  <div class="jumbotron">
    <loading :active.sync="loading"></loading>
    <div class="row">
      <h4>Where do you want to Advertise?</h4>
    </div>
    <div class="row">
      <div class="col">
        <p>ZIP codes are purchased in blocks, see pricing overview for details. You can only advertise in ZIP codes that you service. If you do not see a ZIP code here, add it to your Service Areas under Details.</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h5>Click to remove ZIPs</h5>
      </div>
    </div>
    <div class="row row-margin">
      <div class="col">
        <button v-for="(zip, index) in getZips" :key="index" v-on:click="removeZip(index)" class="btn btn-secondary remove-button">{{ zip }}</button>
      </div>
    </div>
    <div class="row row-margin">
      <div class="col-md-4">
        <h5>Select Package:</h5>
      </div>
      <div class="col">
        <p class="d-inline">Basic</p>
        <label class="switch">
          <input v-model="productType" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p class="d-inline">Pro</p>
      </div>
    </div>
    <div class="row row-margin">
      <div class="col-md-4 my-auto">
        <h5>Monthly Total:</h5>
      </div>
      <div class="col-md-3 text-center my-auto">
        <h5 class="total-cost">${{ cost }}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <router-link to="/profile/business/advertising/priority/overview">
          <button class="btn btn-secondary back-button">Back</button>
        </router-link>
      </div>
      <div class="col-md-6">
        <router-link to="/profile/business/advertising/priority/specialties">
          <button class="btn btn-primary">Select Your Specialties</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Loading
  },
  data () {
    return {
      zip: null,
      showPlaceAlert: false,
      cost: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters('products', [
      'getProduct',
      'getZips'
    ]),
    ...mapGetters('business', [
      'getAreasServiced',
      'getSelectedServices'
    ]),
    productType: {
      get () {
        if (this.getProduct === 'pro') {
          return true
        } else {
          return false
        }
      },
      set (value) {
        if (value) {
          this.updateProduct('pro')
        } else {
          this.updateProduct('basic')
        }
      }
    }
  },
  methods: {
    ...mapMutations('products', [
      'updateProduct',
      'addZip',
      'removeZip',
      'updateZips'
    ]),
    ...mapActions('products', [
      'getPrice'
    ]),
    async checkPrice () {
      this.loading = true
      try {
        this.cost = await this.getPrice()
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    }
  },
  watch: {
    getZips: async function () {
      await this.checkPrice()
    },
    getProduct: async function () {
      await this.checkPrice()
    }
  },
  created () {
    if (!this.getProduct) {
      this.updateProduct('basic')
    }
    this.updateZips(JSON.parse(JSON.stringify(this.getAreasServiced)))
    this.checkPrice()
  }
}
</script>

<style scoped>
.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.remove-button {
  margin-right: 1rem;
  margin-top: .5rem;
}

.btn-primary, .back-button, .btn-full-width {
  width: 100%;
}

.row-margin {
  margin-bottom: 1rem;
}

.total-cost {
  background-color: white;
  padding-top: .5rem;
  padding-bottom: .5rem;
  border-radius: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #FEEDAA;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/priority/subnavItems/Order.vue